import { z } from 'zod';

export const TradingScheduleConfigInputSchema = z.object({
  trade: z.boolean().optional(),
  tradingWindowStart: z.string().optional(),
  tradingWindowEnd: z.string().optional()
});

export type TradingScheduleConfigInput = z.infer<
  typeof TradingScheduleConfigInputSchema
>;
